<template>
    <v-main>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>Manage Permissions </v-card-title>
              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th v-for="(header, h) in headers" :key="`header${h}`">
                        {{ header.text }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in items" :key="`item${i}`">
                      <td>{{ item.name }}</td>
                      <td v-for="(header, i) in headers.slice(1)" :key="i">
                        <div class="form-check">
                          <vs-checkbox
                            v-model="selected[item.id + '' + header.value]"
                            @click="updatePermission(item.id, header.value)"
                          ></vs-checkbox>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        headers: [{ text: "Permissions", value: "permissions" }],
        items: [],
        selected: {},
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      async getData() {
        try {
          const [permissionsResponse, rolesResponse] = await Promise.all([
            axios.get("/permissions"),
            axios.get("/roles?search=all"),
          ]);
  
          const permissions = permissionsResponse.data.data;
          const roles = rolesResponse.data.data;
  
          this.headers = this.headers.concat(
            roles
              .filter((role) => role.name !== "Super Admin")
              .map((role) => ({ text: role.name, value: role.id }))
          );
  
          this.items = permissions.map((permission) => ({
            id: permission.id,
            name: permission.name,
          }));
  
          // Update selected based on permissions assigned to each role
          this.updateSelected(roles);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      },
      async updatePermission(permissionId, roleId) {
        try {
          const permissionKey = permissionId + '' + roleId;
          const isSelected = this.selected[permissionKey];
          const permission_payload = {
            permission_id: permissionId,
            role_id: roleId,
          };
  
          if (isSelected) {
            await axios.post("/unassign_permissions", permission_payload);
          } else {
            await axios.post("/assign_permissions", permission_payload);
          }
  
          // Toggle selected state
          this.$set(this.selected, permissionKey, !isSelected);
        } catch (error) {
          console.error("Error updating permission:", error);
        }
      },
      async updateSelected(roles) {
        try {
          const selected = {};
  
          for (const role of roles) {
            for (const permission of role.permissions) {
              selected[permission.id + '' + role.id] = true;
            }
          }
  
          this.selected = selected;
        } catch (error) {
          console.error("Error updating selected permissions:", error);
        }
      },
    },
  };
  </script>
  
  <style>
  /* Add your CSS styles here */
  </style>
  